// @flow
export const IN_PROGRESS = 'IN_PROGRESS'
export const ERROR = 'ERROR'
export const SUCCESS = 'SUCCESS'
export const TIMEOUT = 'TIMEOUT'
export const UNKNOWN = 'UNKNOWN'
export const STATUSES = [IN_PROGRESS, ERROR, SUCCESS, TIMEOUT, UNKNOWN]
export const PREFIX = '@@fc-requests/'

export const CREATE_REQUEST = `${PREFIX}CREATE_REQUEST`
export const UPDATE_REQUEST = `${PREFIX}UPDATE_REQUEST`
export const DELETE_REQUEST = `${PREFIX}DELETE_REQUEST`

export const GET = 'GET'
export const POST = 'POST'
export const PUT = 'PUT'
export const DELETE = 'DELETE'

// Model Properties
export const PROP_ID = 'id'
export const PROP_REQUEST_ID = PROP_ID
export const PROP_TYPE = 'type'
export const PROP_START = 'start'
export const PROP_END = 'end'
export const PROP_CODE = 'code'
export const PROP_ERRORS = 'errors'
export const PROP_STATUS = 'status'
export const PROP_RESPONSE = 'response'
export const PROP_QUERY_PARAMS = 'queryParams'
export const PROP_MODEL_ID = 'modelId'
export const PROP_URL = 'url'

// Request Components
export const TITLE = 'Title'
export const MESSAGE = 'Message'
